import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import { Checkbox } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import { List, ListItem } from '@dbk/ui-list'
import DocUploadContractList from '../common/doc-upload-contract-list'
import DocuploadPreview from '../doc-upload-preview';
import { DOC_UPLOAD } from '../../../../constants';
import BlurModal from '../../../../components/common/blur-modal';
import { NotificationWarning } from '@dbk/ui-icons';
import md5 from 'md5';

let finalResponse= [];
let retryCounterArray=[];
class DocUploadConditions extends PureComponent {

  constructor(props) {
    super(props)
  }

  componentDidMount(){
    this.acceptHandled();
    retryCounterArray=[];
  }

  state = {
    modalVisible: false,
    documentId: null,
    docName: null,
    pdfByteStream: '',
    downloadInProgress: false,
    extType: '',
    documentType: '',
    isChecked: false,
    newAcceptance: [],
    isSubmitBtnDisabled: true,
  }

  acceptHandled() {
    const { docupload: { acceptances } } = this.props;
    const newOptions = acceptances.map((item) => {
      item.isChecked = false;
      return item;
    })
    this.setState({
      newAcceptance: newOptions
    })

  }

  componentWillReceiveProps(nextProps){
    const { docupload: { uploadFormData, callFinalizeDocUpload, setDocUploadWizardIndex, 
      setFinalizeChunkSuccess, selectedContractDetails } } = this.props;

    if(nextProps.docupload.finalizeChunkSuccess){
      uploadFormData.formDataObj.docMetadataId = nextProps.docupload.docMetaDataId;
      callFinalizeDocUpload(selectedContractDetails, uploadFormData.formDataObj);
      setDocUploadWizardIndex(3);
      setFinalizeChunkSuccess(false);
    }
  }

  closePdf = () => {
    this.setState({ documentId: null });
  }

  closeBlurModelPreview = () => {
    if (this.state.documentId != null) {
      return;
    }
    this.setState({ modalVisible: false, docName: null, documentId: null, pdfByteStream: '', extType: '', documentType: '' });
  }

  openPDf() {
    this.setState({ openModal: true })
    this.setState({
      modalVisible: true, documentId: 82349003, docName: this.props.docupload.uploadFormData.browseFileName.name,
      pdfByteStream: '', extType: '', documentType: ''
    });
  }

  onConditionChecked(e, options) {
    const newSelOptions = this.state.newAcceptance.map((item) => {
      if (options.msgTxt === item.msgTxt) {
        item.isChecked = !item.isChecked;
      }
      return item;
    })
    this.setState({
      newAcceptance: newSelOptions,
    });

    const newArray = newSelOptions.filter(el => el.isChecked === false);

  newArray.length >= 1 ? this.setState({
          isSubmitBtnDisabled: true
        }) : this.setState({
          isSubmitBtnDisabled: false,
    })
  }

  onSubmitHandled() {

    const { docupload: { setDocUploadWizardIndex, uploadFormData,
      setDocMetadataId, setBlurModalError, setDocuploadLoading,
      callFinalizeDocUpload, selectedContractDetails },
      auth: { authHeader, userId },
      settings: { currentEnvironment: { remoteUrl } } } = this.props;

    setDocuploadLoading(true);
    if (uploadFormData.browseFileName && !uploadFormData.base64DataArray) {
      const requestBody = {
        adminUserId: userId,
        fileName: uploadFormData.browseFileName.name,
        contentType: uploadFormData.browseFileName.type,
        data: uploadFormData && uploadFormData.base64Data
      }
      const RSA_URL = remoteUrl +'/rmaccess/' + this.props.app.config.apiverion + '/upload'; // PROD
    
      const req = new XMLHttpRequest();
      req.open('POST', RSA_URL);
      req.setRequestHeader('Authorization-Token', authHeader);
      // Enable for local testing
      //req.setRequestHeader('Authorization','Bearer cb7fe76d4f13fdfdac7028d9950ff9c9');
      req.setRequestHeader('Content-Type', "application/json");
      req.send(JSON.stringify(requestBody));
      req.onload = function (e) {
        try {
          setDocuploadLoading(false);
          if (req.status === 200) {
            const jsonResponse = JSON.parse(req.responseText);
            if (jsonResponse.retCode === "0") {
              setDocMetadataId(jsonResponse.docMetadataId);
              if (jsonResponse && jsonResponse.docMetadataId) {
                uploadFormData.formDataObj.docMetadataId = jsonResponse.docMetadataId;
                callFinalizeDocUpload(selectedContractDetails, uploadFormData.formDataObj);
                setDocUploadWizardIndex(3);
              } else {
                setBlurModalError(true)
              }
            }
          }
          else {
            setBlurModalError(true)
          }
        }
        catch (error) {
          setBlurModalError(true)
        }
      };
      req.onerror = function (e) {
        setBlurModalError(true)
      };
    } else {
      //if file size greater than 5MB
      this.uploadBigFile();
      }
  }

  uploadBigFile(){

    const { docupload: { uploadFormData,
      setBlurModalError, setDocuploadLoading,
      setShowErrorModalFinalize } ,
      auth: { authHeader, userId },
      settings: { currentEnvironment: { remoteUrl } },
      app: { config: { parallelCallCount }} } = this.props;

    const md5Data = md5(uploadFormData.base64Data);

    const request = {
      adminUserId: userId,
      module: "RM_DOCUMENT_UPLOAD",
      size:uploadFormData.browseFileName.size,
      fileName: uploadFormData.browseFileName.name,
      contentType: uploadFormData.browseFileName.type,
      md5: md5Data,
    }
    const RSA_URL = remoteUrl + '/rmaccess/' + this.props.app.config.apiverion + '/documents/chunks/initialize';
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 
      //'Authorization': 'Bearer cb7fe76d4f13fdfdac7028d9950ff9c9', 
      'Authorization-Token': authHeader,
      },
      body: JSON.stringify(request)
    };
    fetch(RSA_URL, requestOptions)
        .then(response => {  if(response.status === 200 ) {
          return response.json();
        } else { setDocuploadLoading(false);} })
        .then(async (resData) => {
         
          if(resData && resData.fileReference){
            uploadFormData.formDataObj.fileReference = resData.fileReference;
            
           const parallelCallCountNew = parallelCallCount || 1 ;  //parallel call counter
           
              let newMd5Data =''
              let parallelCallResponse = [];

              //if chunk array size is less than thread count
              if(parallelCallCountNew > uploadFormData.base64DataArray.length){
                for (let i=0; i<uploadFormData.base64DataArray.length; i++) {
                  //convert chunk to md5
                  newMd5Data = md5(uploadFormData.base64DataArray[i]);
                  parallelCallResponse[i] = this.addChunk(resData.fileReference,uploadFormData.base64DataArray[i],i+1, newMd5Data );
                }
                await Promise.all(...[parallelCallResponse])
                        .then((responses) => {
                          responses.map((response) => {
                            if(response)finalResponse.push(response);
                          });
                        })
              }else{      //if chunk array size is greater than thread count
                  for( let i=0; i <uploadFormData.base64DataArray.length; i+= parallelCallCountNew ) {
                      const base64DataArrayTobeConvertedToChunk = uploadFormData.base64DataArray.slice(i, i + parallelCallCountNew);

                      for (let j=0; j < base64DataArrayTobeConvertedToChunk.length; j++ ) {
                         //convert chunk to md5
                        newMd5Data = md5(base64DataArrayTobeConvertedToChunk[j]);
                        let k = j+i;
                        parallelCallResponse[k] = this.addChunk(resData.fileReference, uploadFormData.base64DataArray[k], k+1, newMd5Data);
                        
                      }

                      await Promise.all(...[parallelCallResponse])
                        .then((responses) => {
                          parallelCallResponse=[];
                              responses.map((response) => {
                                if(response){
                                  finalResponse.push(response);
                                }
                              });
                            })
                    }
                }

              finalResponse.map((item, index) => {
                if(item.status !== 200){
                  if(isNaN(retryCounterArray[index])){
                    retryCounterArray[index] = 1;
                  }else{
                    retryCounterArray[index]+= 1;
                  }
                   this.updateChunk(index);
                }
              })
              this.finalizeChunkCall(finalResponse);
             }else{
              setBlurModalError(true);
              setShowErrorModalFinalize(true);
             }
          }
       );
  }
  
  updateChunk(index){
    const { docupload: { uploadFormData, setBlurModalError, setShowErrorModalFinalize } } = this.props;
    
    const chunkData= uploadFormData && uploadFormData.base64DataArray[index];
    const md5Data= md5(uploadFormData.base64DataArray[index])

    const self = this;
    
    this.addChunk(uploadFormData.formDataObj.fileReference, chunkData, index +1, md5Data, 1)
      .then( function (response) {
            if(response && response.status === 200){
              finalResponse[index] = response ;
              self.finalizeChunkCall(finalResponse);
            }else if(retryCounterArray[index] < 2 ){
                retryCounterArray[index]+= 1;
                self.updateChunk(index);
              }else{
                setBlurModalError(true);
                setShowErrorModalFinalize(true);
              }
        })
  }

  addChunk(uuid, chunkData, order, chunkMd5Data) {
    const { settings: { currentEnvironment: { remoteUrl } }, auth: { authHeader, userId }} = this.props;

    const RSA_URL = remoteUrl + '/rmaccess/' + this.props.app.config.apiverion + '/documents/chunks/add';
    const dataBody = {
      fileReference: uuid,
      chunk:chunkData,
      order,
      md5: chunkMd5Data,
      adminUserId: userId
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 
      //'Authorization': 'Bearer cb7fe76d4f13fdfdac7028d9950ff9c9', 
      'Authorization-Token': authHeader,
      },
      body: JSON.stringify(dataBody)
    };
    if(chunkData){ return fetch(RSA_URL, requestOptions) }
  }

  //call chunk finalize endpoint 
  finalizeChunkCall(response){
    const { docupload: { uploadFormData, callFinalizechunkUpload } } = this.props;

    const successes = finalResponse.filter(res => res.status === 200);
    if(response.length === successes.length ){
      callFinalizechunkUpload(uploadFormData.formDataObj.fileReference);
    }
  }

  onBack() {
    const { docupload: { setDocUploadWizardIndex } } = this.props;
    setDocUploadWizardIndex(1);
  }

  closeBlurModel = () => {
    this.props.docupload.setBlurModalError(false);
  }

  renderErrorModal = () => {
    const { i18n: { messages }, docupload: { showErrorModalFinalize, errorTitle, errorMsg } } = this.props;

    return (
        <BlurModal
            visible={showErrorModalFinalize}
            doneVisible={false}
            title={<h4>{errorTitle || messages['app.docUpload.upload.errorTitle']}</h4>}
            onDone={() => this.closeBlurModel()}
        >
            <div className="error-message-container">
                <NotificationWarning color='#b92635' className="error-icon" width={25} height={25} />
                <span className="error-message-content">{errorMsg || messages['app.docUpload.upload.error']}</span>
            </div>
        </BlurModal>
    )
  }

  componentWillUnmount(){
    const { docupload: { setDocuploadLoading } } = this.props;
    setDocuploadLoading(false);
    finalResponse=[];
    retryCounterArray=[];
  }

  render() {

    const { i18n: { messages },docupload:{ selectedContractDetails, uploadFormData, showErrorModal, loading } } = this.props;
    return (
      <div className="columns small-12
                           medium-12 large-12
                           document-upload">

      <div className="doc-upload-confirmation-page">
        <div className="confirmation-container">
            <DocUploadContractList
              contractListData={selectedContractDetails}
              disabled={true}
            />
            <div>
              <Text size="big" className="confirmation-heading"> {messages['app.confiramtionPage.heading']}</Text>
            </div>
            <div className="confirmation-wrapper">
              <List
                TestID="acceptanceList"
                style={{ maxWidth: 'none', height: '226px' }} >
                {this.state.newAcceptance.map((option) =>
                  <ListItem
                    style={{ border: 'none' }}>

                    <div className="confirmation-wrapper.heading">
                      <Checkbox checked={option.isChecked} onChange={(e) => this.onConditionChecked(e, option)} /><Text className="confirmation-wrapper-text contract-list-item">{option.msgTxt}</Text>
                    </div>

                  </ListItem>)}
              </List></div>
            <DocuploadPreview
              screen={screen}
              modalVisible={this.state.modalVisible}
              doneLabel="Close"
              onCloseBlurModel={this.closeBlurModelPreview}
              headerLabel={this.state.docName}
              closePdf={this.closePdf}
              pdfData={uploadFormData.base64Data}
              messages={messages}
              pdfDataDownloadInProgress={this.state.downloadInProgress}
              extType={this.state.extType}
              documentType={this.state.documentType}
            />

            <div className="doc-upload-confirmation-page-bottom-buttons">
              <div className='margin-right-10'>
                <Button
                  secondary
                  textID="btn_uploadDoc_condition_viewDoc_test"
                  accessibilityLabel="btn_uploadDoc_condition_viewDoc_test"
                  size="large"
                  disabled={!(uploadFormData.browseFileName.type === DOC_UPLOAD.DOC_TYPE)}
                  onPress={() => this.openPDf()}>
                  {messages['app.confirmationPage.ViewDocumentButton']}
                </Button>
              </div>
              <div>
                <Button
                  tertiary
                  textID="btn_uploadDoc_condition_back_test"
                  accessibilityLabel="btn_uploadDoc_condition_back_test"
                  size="large"
                  className="backButtonConfirmationPage"
                  onPress={() => this.onBack()}>
                  {messages['app.documentUpload.button.back']}
                </Button>
              </div>
              <div>
                <Button
                  size='large'
                  textID="btn_uploadDoc_condition_continue_test"
                  accessibilityLabel="btn_uploadDoc_condition_continue_test"
                  disabled={this.state.isSubmitBtnDisabled || loading}
                  loading={loading}
                  onPress={() => this.onSubmitHandled()}
                > {messages['app.documentUpload.button.continue']}
                </Button>
              </div>
            </div>
          </div>
        </div>
        {showErrorModal && this.renderErrorModal()}
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    app: {
      config: {
          apiverion: true,
          parallelCallCount: true,
      },
    },
    settings: {
      currentEnvironment: {
        remoteUrl: true,
      },
    },
    changePage: { $call: 'ui.history.push' },
    rsaChangePage: { $call: 'rsa.changePage' },
    i18n: {
      messages: true,
    },
    docupload: {
      contractDetails: true,
      search: { showSpinner: true },
      setDocUploadWizardIndex: { $set: 'docUploadWizardIndex' },
      selectedContractDetails: true,
      acceptances: true,
      uploadFormData: true,
      callFinalizeDocUpload: { $call: 'finalizeDocUpload' },
      callFinalizechunkUpload: { $call: 'finalizeChunkUpload' },
      setDocMetadataId: { $set: 'docMetaDataId' },
      showErrorModal: true,
      errorTitle: true,
      setBlurModalError: { $set: 'showErrorModal' },
      loading: true,
      setDocuploadLoading: { $set: 'loading' },
      finalizeChunkSuccess: true,
      setFinalizeChunkSuccess: { $set: 'finalizeChunkSuccess'},
      docMetaDataId:true,
      showErrorModalFinalize: true,
      setShowErrorModalFinalize: { $set: 'showErrorModalFinalize' }
    },
    auth: {
      userId: true,
      authHeader: true,
      langCode: true
    },
    screen: {
      width: true,
      height: true,
      isSmall: true
    },
  }
})(DocUploadConditions)
